import React, { useState, useRef } from "react";
import SignatureCanvas from "react-signature-canvas";
import { useNavigate } from "react-router-dom";
import FormHeader from "../common/FormHeader";
import "./formTitle.css";
import "./themePlaceholder.css";

function PreFabricated() {
  const navigate = useNavigate();
  const sigCanvasRef1 = useRef(null);
  const sigCanvasRef2 = useRef(null);
  const [form, setForm] = useState({
    inspector: "",
    inspectorEmpNo: "",
    inspectorPasma: "",
    userName1: "",
    userEmpNo1: "",
    userPasma1: "",
    userName2: "",
    userEmpNo2: "",
    userPasma2: "",
    inspectionDate: "",
    towerNo: "",
    platformHeight: "",
    projectJobNo: "",
    location: "",
    reason: "",
    plannedWork: "",
    emergencyWork: "",
    riskAssessment: "",
    manualRead: "",
    componentsCompatible: "",
    electricalSafety: "",
    built3T: "",
    baseLevel: "",
    heightBaseRatio: "",
    castorsStable: "",
    wingNutsTight: "",
    exclusionZone: ""
  });

  const handleChange = (e) => {
    setForm({ ...form, [e.target.name]: e.target.value });
  };

  // Signature pad handlers for first signature
  const clearSignature1 = () => {
    sigCanvasRef1.current.clear();
    setForm(prev => ({ ...prev, inspectorSignature: "" }));
  };
  const saveSignature1 = () => {
    if (!sigCanvasRef1.current.isEmpty()) {
      setForm(prev => ({ ...prev, inspectorSignature: sigCanvasRef1.current.getTrimmedCanvas().toDataURL("image/png") }));
    }
  };
  // Signature pad handlers for second signature
  const clearSignature2 = () => {
    sigCanvasRef2.current.clear();
    setForm(prev => ({ ...prev, inspectorSignature2: "" }));
  };
  const saveSignature2 = () => {
    if (!sigCanvasRef2.current.isEmpty()) {
      setForm(prev => ({ ...prev, inspectorSignature2: sigCanvasRef2.current.getTrimmedCanvas().toDataURL("image/png") }));
    }
  };

  const handleSubmit = (e) => {
    e.preventDefault();
    alert("Pre Fabricated Form submitted!");
    navigate(-1);
  };

  return (
    <div style={{ height: "100vh", overflowY: "auto", background: "#f5f7fa" }}>
      <FormHeader />
      <div className="container py-4">
     
        <div className="card shadow-sm rounded-4 p-4">
          <h2 className="text-center text-white py-2 mb-4 rounded" style={{ backgroundColor: "#8b1634", letterSpacing: "1px", fontSize: "1.8rem" }}>
            Pre Fabricated Form
          </h2>
          <form onSubmit={handleSubmit}>
            <div className="row g-4">
              <div className="col-12">
                <span className="fw-bold" style={{ color: "#8b1634", fontSize: "1.1rem", display: "block", marginBottom: "8px" }}>
                  Prefabricated Scaffold Tower Inspection Record
                </span>
                <div className="card p-3 mb-4" style={{ background: "#faf9fa", borderRadius: "18px", border: "1.5px solid #8b1634" }}>
                  <input
                    type="text"
                    className="form-control mb-3"
                    name="inspector"
                    value={form.inspector}
                    onChange={handleChange}
                    required
                    placeholder="Inspector"
                    style={{ background: "#f7fafd", borderRadius: "10px", border: "2px solid #8b1634", fontSize: "1.08rem" }}
                  />
                  <input
                    type="text"
                    className="form-control mb-3"
                    name="inspectorEmpNo"
                    value={form.inspectorEmpNo}
                    onChange={handleChange}
                    required
                    placeholder="Employee No."
                    style={{ background: "#f7fafd", borderRadius: "10px", border: "2px solid #8b1634", fontSize: "1.08rem" }}
                  />
                  <input
                    type="text"
                    className="form-control mb-3"
                    name="inspectorPasma"
                    value={form.inspectorPasma}
                    onChange={handleChange}
                    required
                    placeholder="PASMA Card No."
                    style={{ background: "#f7fafd", borderRadius: "10px", border: "2px solid #8b1634", fontSize: "1.08rem" }}
                  />
                </div>
                {/* User 1 */}
                <div className="card p-3 mb-4" style={{ background: "#faf9fa", borderRadius: "18px", border: "1.5px solid #8b1634" }}>
                  <input
                    type="text"
                    className="form-control mb-3"
                    name="userName1"
                    value={form.userName1}
                    onChange={handleChange}
                    required
                    placeholder="User Name"
                    style={{ background: "#f7fafd", borderRadius: "10px", border: "2px solid #8b1634", fontSize: "1.08rem" }}
                  />
                  <input
                    type="text"
                    className="form-control mb-3"
                    name="userEmpNo1"
                    value={form.userEmpNo1}
                    onChange={handleChange}
                    required
                    placeholder="Employee No."
                    style={{ background: "#f7fafd", borderRadius: "10px", border: "2px solid #8b1634", fontSize: "1.08rem" }}
                  />
                  <input
                    type="text"
                    className="form-control mb-3"
                    name="userPasma1"
                    value={form.userPasma1}
                    onChange={handleChange}
                    required
                    placeholder="PASMA Card No."
                    style={{ background: "#f7fafd", borderRadius: "10px", border: "2px solid #8b1634", fontSize: "1.08rem" }}
                  />
                </div>
                {/* User 2 */}
                <div className="card p-3 mb-4" style={{ background: "#faf9fa", borderRadius: "18px", border: "1.5px solid #8b1634" }}>
                  <input
                    type="text"
                    className="form-control mb-3"
                    name="userName2"
                    value={form.userName2}
                    onChange={handleChange}
                    required
                    placeholder="User Name"
                    style={{ background: "#f7fafd", borderRadius: "10px", border: "2px solid #8b1634", fontSize: "1.08rem" }}
                  />
                  <input
                    type="text"
                    className="form-control mb-3"
                    name="userEmpNo2"
                    value={form.userEmpNo2}
                    onChange={handleChange}
                    required
                    placeholder="Employee No."
                    style={{ background: "#f7fafd", borderRadius: "10px", border: "2px solid #8b1634", fontSize: "1.08rem" }}
                  />
                  <input
                    type="text"
                    className="form-control mb-3"
                    name="userPasma2"
                    value={form.userPasma2}
                    onChange={handleChange}
                    required
                    placeholder="PASMA Card No."
                    style={{ background: "#f7fafd", borderRadius: "10px", border: "2px solid #8b1634", fontSize: "1.08rem" }}
                  />
                </div>
                {/* Inspection Details */}
                <div className="card p-3 mb-4" style={{ background: "#faf9fa", borderRadius: "18px", border: "1.5px solid #8b1634" }}>
                  <input
                    type="date"
                    className="form-control mb-3"
                    name="inspectionDate"
                    value={form.inspectionDate}
                    onChange={handleChange}
                    required
                    placeholder="Inspection Date"
                    style={{ background: "#f7fafd", borderRadius: "10px", border: "2px solid #8b1634", fontSize: "1.08rem" }}
                  />
                  <input
                    type="text"
                    className="form-control mb-3"
                    name="towerNo"
                    value={form.towerNo}
                    onChange={handleChange}
                    required
                    placeholder="Tower No."
                    style={{ background: "#f7fafd", borderRadius: "10px", border: "2px solid #8b1634", fontSize: "1.08rem" }}
                  />
                  <input
                    type="text"
                    className="form-control mb-3"
                    name="platformHeight"
                    value={form.platformHeight}
                    onChange={handleChange}
                    required
                    placeholder="Platform Height"
                    style={{ background: "#f7fafd", borderRadius: "10px", border: "2px solid #8b1634", fontSize: "1.08rem" }}
                  />
                </div>
                {/* Project/Job No. and Location */}
                <div className="card p-3 mb-4" style={{ background: "#faf9fa", borderRadius: "18px", border: "1.5px solid #8b1634" }}>
                  <input
                    type="text"
                    className="form-control mb-3"
                    name="projectJobNo"
                    value={form.projectJobNo}
                    onChange={handleChange}
                    required
                    placeholder="Project/ Job No. and Location"
                    style={{ background: "#f7fafd", borderRadius: "10px", border: "2px solid #8b1634", fontSize: "1.08rem" }}
                  />
                  <input
                    type="text"
                    className="form-control mb-3"
                    name="reason"
                    value={form.reason}
                    onChange={handleChange}
                    required
                    placeholder="Reason for Tower Scaffold Use"
                    style={{ background: "#f7fafd", borderRadius: "10px", border: "2px solid #8b1634", fontSize: "1.08rem" }}
                  />
                </div>
                {/* Instructional Text and Inspection Checklist */}
                <div className="mb-4">
                  <div className="card p-3 mb-3" style={{ background: "#fff7fa", borderRadius: "18px", border: "1.5px solid #8b1634" }}>
                    <div style={{ color: "#8b1634", fontWeight: "bold", fontSize: "1.08rem" }}>
                      Inspections of Mobile Access Towers shall take place at the following times
                    </div>
                    <ul style={{ marginTop: "8px", marginBottom: "8px" }}>
                      <li>After assembly and before use.</li>
                      <li>After any event likely affected its stability,</li>
                      <li>At intervals not exceeding 7 days.</li>
                    </ul>
                  </div>
                  {/* Instructional text outside card */}
                  <div className="mb-3" style={{ fontWeight: "bold", color: "#8b1634", fontSize: "1.08rem" }}>
                    Mark Each Section as follows: YES – Compliance/ Correctly working or NO – Non-Compliant/ Incorrectly Working: <span style={{ color: "#d32f2f" }}>STOP! Do Not Continue until corrective action is taken</span>
                  </div>
                  <div className="card p-3" style={{ background: "#faf9fa", borderRadius: "18px", border: "1.5px solid #8b1634" }}>
                    <div className="fw-bold mb-2" style={{ color: "#8b1634" }}>BEFORE AND DURING CONSTRUCTION</div>
                    {/* Checklist Items */}
                    {[
                      {
                        label: "Planned Work: Pre-Site Visit documentation identifying Tower Scaffold to be used remains valid.",
                        name: "plannedWork"
                      },
                      {
                        label: "Unplanned Emergency/Fault Work: Working at height is justified (Using Hierarchy), MEWP can not be used, Use of Tower Scaffold fully justified on On-Site (Point of Work) Risk Assessment.",
                        name: "emergencyWork"
                      },
                      {
                        label: "On-Site (Point of Work) Risk Assessment is completed on site.",
                        name: "riskAssessment"
                      },
                      {
                        label: "Manufacturer’s instruction manual on site and has been read and understood.",
                        name: "manualRead"
                      },
                      {
                        label: "All components are from same manufacturer, are compatible and inspected prior to assembly.",
                        name: "componentsCompatible"
                      },
                      {
                        label: "If working near or adjacent to electrical conductors, these are made dead and isolated or are fully shrouded to avoid contact in accordance with the Distribution Safety Rules.",
                        name: "electricalSafety"
                      },
                      {
                        label: "Tower is built in accordance with the manufacturers instructions using the 3T method.",
                        name: "built3T"
                      },
                      {
                        label: "The tower base is level and vertical in both planes.",
                        name: "baseLevel"
                      },
                      {
                        label: "The height to base ratio has been checked and is correct.",
                        name: "heightBaseRatio"
                      },
                      {
                        label: "Castors or base plates and stabilisers/outriggers are correctly fitted and the surface they are on is firm and stable. All castors are locked/braked.",
                        name: "castorsStable"
                      },
                      {
                        label: "All wing nuts on the stabilisers have been checked to ensure they are fully tightened.",
                        name: "wingNutsTight"
                      },
                      {
                        label: "Appropriate exclusion zone in place (use warning signs, traffic control and barriers as appropriate) to prevent unauthorised access.",
                        name: "exclusionZone"
                      }
                    ].map((item, idx) => (
                      <div key={item.name} className="mb-3">
                        <div style={{ fontWeight: "500", marginBottom: "6px" }}>{idx + 1}. {item.label}</div>
                        <div>
                          <label className="me-3">
                            <input
                              type="radio"
                              name={item.name}
                              value="yes"
                              checked={form[item.name] === "yes"}
                              onChange={handleChange}
                              required
                            /> YES
                          </label>
                          <label>
                            <input
                              type="radio"
                              name={item.name}
                              value="no"
                              checked={form[item.name] === "no"}
                              onChange={handleChange}
                              required
                            /> NO
                          </label>
                        </div>
                      </div>
                    ))}
                    {/* Continue checklist: Questions 12-15 */}
                    <div className="mb-3">
                      <div style={{ fontWeight: "500", marginBottom: "6px" }}>12. Appropriate exclusion zone in place (use warning signs, traffic control and barriers as appropriate) to prevent collision/falling objects causing injury etc.</div>
                      <div>
                        <label className="me-3">
                          <input type="radio" name="exclusionZone2" value="yes" checked={form.exclusionZone2 === "yes"} onChange={handleChange} required /> YES
                        </label>
                        <label>
                          <input type="radio" name="exclusionZone2" value="no" checked={form.exclusionZone2 === "no"} onChange={handleChange} required /> NO
                        </label>
                      </div>
                    </div>
                    <div className="mb-3">
                      <div style={{ fontWeight: "500", marginBottom: "6px" }}>13. All platforms that are to be used either for storing items or as a working platform have been checked to ensure they are fitted with toe-boards, guard rails and that the hatch still opens easily.</div>
                      <div>
                        <label className="me-3">
                          <input type="radio" name="platformChecked" value="yes" checked={form.platformChecked === "yes"} onChange={handleChange} required /> YES
                        </label>
                        <label>
                          <input type="radio" name="platformChecked" value="no" checked={form.platformChecked === "no"} onChange={handleChange} required /> NO
                        </label>
                      </div>
                    </div>
                    <div className="mb-3">
                      <div style={{ fontWeight: "500", marginBottom: "6px" }}>14. If appropriate the tower is earthed in accordance with Distribution Safety Rules or other operational procedure requirements.</div>
                      <div>
                        <label className="me-3">
                          <input type="radio" name="towerEarthed" value="yes" checked={form.towerEarthed === "yes"} onChange={handleChange} required /> YES
                        </label>
                        <label>
                          <input type="radio" name="towerEarthed" value="no" checked={form.towerEarthed === "no"} onChange={handleChange} required /> NO
                        </label>
                      </div>
                    </div>
                    <div className="mb-3">
                      <div style={{ fontWeight: "500", marginBottom: "6px" }}>15. Final inspection completed, the Scaff-Tag has been completed signed and fitted to the tower.</div>
                      <div>
                        <label className="me-3">
                          <input type="radio" name="scaffTag" value="yes" checked={form.scaffTag === "yes"} onChange={handleChange} required /> YES
                        </label>
                        <label>
                          <input type="radio" name="scaffTag" value="no" checked={form.scaffTag === "no"} onChange={handleChange} required /> NO
                        </label>
                      </div>
                    </div>
                    {/* Inspector Details fields - no border, no extra div */}
                    <input
                      type="text"
                      className="form-control mb-3"
                      name="printName"
                      value={form.printName || ""}
                      onChange={handleChange}
                      required
                      placeholder="PRINT NAME"
                      style={{ background: "#f7fafd", borderRadius: "10px", border: "2px solid #8b1634", fontSize: "1.08rem" }}
                    />
                    <input
                      type="date"
                      className="form-control mb-3"
                      name="inspectorDate"
                      value={form.inspectorDate || ""}
                      onChange={handleChange}
                      required
                      placeholder="DATE"
                      style={{ background: "#f7fafd", borderRadius: "10px", border: "2px solid #8b1634", fontSize: "1.08rem" }}
                    />
                    <div className="mb-2 fw-bold" style={{ color: "#8b1634" }}>INSPECTOR'S SIGNATURE</div>
                    <div className="col-md-4 mb-2">
                      <div style={{
                        width: '100%',
                        border: '2px solid #8b1634',
                        borderRadius: '18px',
                        background: '#e9cfd6',
                        padding: '0.5rem',
                        textAlign: 'left',
                        position: 'relative',
                        minHeight: '140px',
                        display: 'flex',
                        flexDirection: 'column',
                        justifyContent: 'center'
                      }}>
                        <SignatureCanvas
                          ref={sigCanvasRef1}
                          penColor="#8b1634"
                          backgroundColor="#e9cfd6"
                          clearOnResize={false}
                          velocityFilterWeight={0.7}
                          minWidth={1}
                          maxWidth={2.5}
                          dotSize={1.5}
                          throttle={16}
                          canvasProps={{
                            width: 350,
                            height: 120,
                            style: {
                              width: '100%',
                              height: '120px',
                              border: 'none',
                              borderRadius: '18px',
                              background: '#e9cfd6',
                              display: 'block',
                              touchAction: 'none'
                            }
                          }}
                          onEnd={saveSignature1}
                        />
                      </div>
                      <div style={{ width: '100%', display: 'flex', justifyContent: 'flex-end', marginTop: '4px' }}>
                        <button
                          type="button"
                          className="btn btn-outline-danger btn-sm rounded-pill px-3"
                          style={{ background: 'transparent', color: '#8b1634', borderColor: '#8b1634' }}
                          onClick={clearSignature1}>
                          Clear
                        </button>
                      </div>
                    </div>
                    {/* Note and Dismantlement Section */}
                    <div className="mb-3 mt-4">
                      <div style={{ fontWeight: "bold", color: "#333", marginBottom: "10px" }}>
                        Note: <span style={{ fontWeight: "normal" }}>If any alterations are undertaken on the Tower a new Inspection record must be completed</span>
                      </div>
                      <div style={{ fontWeight: "500", color: "#8b1634", marginBottom: "6px" }}>16. Dismantlement is carried out in accordance with the manufacturers instructions</div>
                      <div>
                        <label className="me-3">
                          <input type="radio" name="dismantleInstructions" value="yes" checked={form.dismantleInstructions === "yes"} onChange={handleChange} required /> YES
                        </label>
                        <label>
                          <input type="radio" name="dismantleInstructions" value="no" checked={form.dismantleInstructions === "no"} onChange={handleChange} required /> NO
                        </label>
                      </div>
                      <div style={{ fontWeight: "500", color: "#8b1634", marginTop: "18px", marginBottom: "6px" }}>17. Dismantlement is carried out using the 3T method</div>
                      <div>
                        <label className="me-3">
                          <input type="radio" name="dismantle3T" value="yes" checked={form.dismantle3T === "yes"} onChange={handleChange} required /> YES
                        </label>
                        <label>
                          <input type="radio" name="dismantle3T" value="no" checked={form.dismantle3T === "no"} onChange={handleChange} required /> NO
                        </label>
                      </div>
                    </div>
                    {/* Second Inspector Details block */}
                    <input
                      type="text"
                      className="form-control mb-3"
                      name="printName2"
                      value={form.printName2 || ""}
                      onChange={handleChange}
                      required
                      placeholder="PRINT NAME"
                      style={{ background: "#f7fafd", borderRadius: "10px", border: "2px solid #8b1634", fontSize: "1.08rem" }}
                    />
                    <input
                      type="date"
                      className="form-control mb-3"
                      name="inspectorDate2"
                      value={form.inspectorDate2 || ""}
                      onChange={handleChange}
                      required
                      placeholder="DATE"
                      style={{ background: "#f7fafd", borderRadius: "10px", border: "2px solid #8b1634", fontSize: "1.08rem" }}
                    />
                    <div className="mb-2 fw-bold" style={{ color: "#8b1634" }}>INSPECTOR'S SIGNATURE</div>
                    <div className="col-md-4 mb-2">
                      <div style={{
                        width: '100%',
                        border: '2px solid #8b1634',
                        borderRadius: '18px',
                        background: '#e9cfd6',
                        padding: '0.5rem',
                        textAlign: 'left',
                        position: 'relative',
                        minHeight: '140px',
                        display: 'flex',
                        flexDirection: 'column',
                        justifyContent: 'center'
                      }}>
                        <SignatureCanvas
                          ref={sigCanvasRef2}
                          penColor="#8b1634"
                          backgroundColor="#e9cfd6"
                          clearOnResize={false}
                          velocityFilterWeight={0.7}
                          minWidth={1}
                          maxWidth={2.5}
                          dotSize={1.5}
                          throttle={16}
                          canvasProps={{
                            width: 350,
                            height: 120,
                            style: {
                              width: '100%',
                              height: '120px',
                              border: 'none',
                              borderRadius: '18px',
                              background: '#e9cfd6',
                              display: 'block',
                              touchAction: 'none'
                            }
                          }}
                          onEnd={saveSignature2}
                        />
                      </div>
                      <div style={{ width: '100%', display: 'flex', justifyContent: 'flex-end', marginTop: '4px' }}>
                        <button
                          type="button"
                          className="btn btn-outline-danger btn-sm rounded-pill px-3"
                          style={{ background: 'transparent', color: '#8b1634', borderColor: '#8b1634' }}
                          onClick={clearSignature2}>
                          Clear
                        </button>
                      </div>
                    </div>
                  </div>
                </div>
              </div>
              {/* Submit Button */}
              <div className="col-12 text-center mt-4">
                <button type="submit" className="btn btn-lg text-white fw-bold px-5 py-2"
                  style={{
                    backgroundColor: "#8b1634",
                    borderRadius: "30px",
                    boxShadow: "0 4px 12px rgba(139,22,52,0.3)"
                  }}>
                  Submit
                </button>
              </div>
            </div>
          </form>
        </div>
      </div>
    </div>
  );
}
export default PreFabricated;
